<template>
  <!-- venue-categoris-section-->
  <div class="space-medium bg-white">
      <div class="container">
          <div class="row">
              <div class="offset-xl-2 col-xl-8 offset-lg-2 col-lg-8 col-md-12 col-sm-12 col-12">
                  <div class="section-title text-center">
                      <!-- section title start-->
                      <h2 class="mb10">Browse Vendors by Category</h2>
                      <p>You can browse all venues by category with thumbnail image and category name.</p>
                  </div>
                  <!-- /.section title start-->
              </div>
          </div>
          <div class="row">
              <!-- venue-categoris-block-->
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div class="vendor-categories-block zoomimg">
                      <div class="vendor-categories-img"> <a href="#"><img src="https://media.allaboutwedding.com/media-import/medium-box/merchant/278/1.jpg" alt="" class="img-fluid"></a></div>
                      <div class="vendor-categories-overlay">
                          <div class="vendor-categories-text">
                              <h4 class="mb0"><a href="#" class="vendor-categories-title">Wedding Gown</a></h4>
                              <p class="vendor-categories-numbers">5</p>
                          </div>
                      </div>
                  </div>
                  <!-- /.venue-categoris-block-->
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div class="vendor-categories-block zoomimg">
                      <div class="vendor-categories-img"> <a href="#"><img src="https://media.allaboutwedding.com/media-import/medium-box/merchant/4/1.jpg" alt="" class="img-fluid"></a></div>
                      <div class="vendor-categories-overlay">
                          <div class="vendor-categories-text">
                              <h4 class="mb0"><a href="#" class="vendor-categories-title">Markup</a></h4>
                              <p class="vendor-categories-numbers">5</p>
                          </div>
                      </div>
                  </div>
                  <!-- /.venue-categoris-block-->
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div class="vendor-categories-block zoomimg">
                      <div class="vendor-categories-img"> <a href="#"><img src="https://media.allaboutwedding.com/media-import/medium-box/merchant/381/1.jpg" alt="" class="img-fluid"></a></div>
                      <div class="vendor-categories-overlay">
                          <div class="vendor-categories-text">
                              <h4 class="mb0"><a href="#" class="vendor-categories-title">Photography</a></h4>
                              <p class="vendor-categories-numbers">12</p>
                          </div>
                      </div>
                  </div>
                  <!-- /.venue-categoris-block-->
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div class="vendor-categories-block zoomimg">
                      <div class="vendor-categories-img"> <a href="#"><img src="https://media.allaboutwedding.com/media/medium-box/1493366736aFed.jpg" alt="" class="img-fluid"></a></div>
                      <div class="vendor-categories-overlay">
                          <div class="vendor-categories-text">
                              <h4 class="mb0"><a href="#" class="vendor-categories-title">Venues</a></h4>
                              <p class="vendor-categories-numbers">14</p>
                          </div>
                      </div>
                  </div>
                  <!-- /.venue-categoris-block-->
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div class="vendor-categories-block zoomimg">
                      <div class="vendor-categories-img"> <a href="#"><img src="https://media.allaboutwedding.com/media-import/medium-box/merchant/659/1.jpg" alt="" class="img-fluid"></a></div>
                      <div class="vendor-categories-overlay">
                          <div class="vendor-categories-text">
                              <h4 class="mb0"><a href="#" class="vendor-categories-title">Wedding Services</a></h4>
                              <p class="vendor-categories-numbers">2</p>
                          </div>
                      </div>
                  </div>
                  <!-- /.venue-categoris-block-->
              </div>
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <div class="vendor-categories-block zoomimg">
                      <div class="vendor-categories-img"> <a href="#"><img src="https://media.allaboutwedding.com/media-import/medium-box/merchant/626/1.jpg" alt="" class="img-fluid"></a></div>
                      <div class="vendor-categories-overlay">
                          <div class="vendor-categories-text">
                              <h4 class="mb0"><a href="#" class="vendor-categories-title">Travel</a></h4>
                              <p class="vendor-categories-numbers">10</p>
                          </div>
                      </div>
                  </div>
                  <!-- /.venue-categoris-block-->
              </div>
          </div>
      </div>
  </div>
  <!-- /.venue-categoris-section-->
</template>
<script>
export default {
  name: "LandingCategory",
  props: {
    msg: String
  }
};
</script>
